import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'wouter'
import { getPosts, getPopularPosts } from '../../actions/postsActions'
import Loader from '../../components/Loader'
import Error from '../../components/Error'
import Post from '../../components/Post'
import Pagination from '../../components/Pagination'
import Headers from '../../components/Header'

import {
  Community,
  CommunityContainer,
  PostsWrapper,
  LeftContent,
  RightContent,
  ListPostContainer,
  Header,
  Title,
  Subtitle,
  CreatePostItem
} from './elements'

export default function CommunityPage({ params }) {
  const dispatch = useDispatch()

  const pageInfo = params.page ? Number(params.page) : 1
  const [_, pushLocation] = useLocation()

  const { error, loading, data = {} } = useSelector(state => state.posts)

  const {
    error: errorPopular,
    loading: loadingPopular,
    popular
  } = useSelector(state => state.postsPopular)

  const { userInfo } = useSelector(state => state.userLogin)

  const { posts = [], page, pages } = data

  useEffect(function () {
    if (!pageInfo || pageInfo < 0) {
      // pushLocation('/comunidad/1')
      pushLocation(`/blog/comunidad/1`)
    } else {
      dispatch(getPosts({ page: pageInfo }))
    }
  }, [pushLocation, pageInfo])

  // get popular posts
  useEffect(function () {
    dispatch(getPopularPosts())
  }, [])

  return (
    <Community>
      <Headers
        title="Blog | Ndolet Corp."
      />
      <CommunityContainer>
        <PostsWrapper>
          <LeftContent>
            <Header>
              <Title>Community Latest Posts</Title>
              <Subtitle>Read the best articles</Subtitle>
              {userInfo &&
                <>
                  Contribute to the community, {' '}
                  <CreatePostItem to={`/blog/nueva/publicacion`}>
                    {/* <CreatePostItem to="/nueva/publicacion"> */}
                    create your own post
                  </CreatePostItem>
                </>
              }
            </Header>
            <ListPostContainer>
              {loading ? (
                <Loader />
              ) :
                error ? (
                  <Error message={error} />
                ) : (
                  <>
                    {posts && posts.length === 0 ? ('There are no posts yet') : (
                      <>
                        {posts.map(post => (
                          <Post key={post._id} {...post} />
                        ))}
                        <Pagination pages={pages} page={page} />
                      </>
                    )}
                  </>
                )}
            </ListPostContainer>
          </LeftContent>
          <RightContent>
            <Header>
              <Title right>
                Popular
              </Title>
              <Subtitle right>
                See what the community likes the most!
              </Subtitle>
            </Header>
            <ListPostContainer>
              {loadingPopular ? (
                <Loader />
              ) :
                errorPopular ? (
                  errorPopular
                ) : (
                  <>
                    {popular && popular.length === 0 ? ('There are no posts yet') : (
                      <>
                        {popular.map(popularItem => (
                          <Post
                            key={popularItem._id}
                            title={popularItem.title}
                            likes={popularItem.likes}
                            user={popularItem.user}
                            slug={popularItem.slug}
                            popular={true}
                          />
                        ))}
                      </>
                    )}
                  </>
                )}
            </ListPostContainer>
          </RightContent>
        </PostsWrapper>
      </CommunityContainer>
    </Community>
  )
}
